import Decimal from 'decimal.js';
import { parseIntlNumber } from 'utils/numberUtils';

/** A row of the manual paste table: the ISIN and the Peso / Controvalore cell as typed. */
export type ManualPortfolioRow = {
  isin: string | null;
  weight: string | null;
};

/** The `fineco_analyze_portfolio_from_weights` action payload the manual table submits. */
export function buildManualPortfolioPayload(rows: ManualPortfolioRow[], byWeights: boolean) {
  const products = [];

  for (let i = 0; i < rows.length; i++) {
    if (!rows[i].isin || !rows[i].weight || rows[i].weight.trim() === '') continue;

    const w = rows[i].weight;
    const p = parseIntlNumber(w);
    if (isNaN(p)) continue;

    const isinObj: { isin: string; weight?: string; value?: string } = {
      isin: rows[i].isin,
    };
    if (byWeights) {
      isinObj.weight = new Decimal(p).dividedBy(100).toFixed();
    } else {
      isinObj.value = new Decimal(p).toFixed();
    }
    products.push(isinObj);
  }

  return {
    by_weights: byWeights,
    products: products,
  };
}
